import React from "react";
import { BreadCrump } from "../BreadCramp/BreadCrump";
import { ProfileSidebar } from "../Profile/ProfileSidebar/ProfileSidebar";
import { BannerHeader, BreadcrumpWrapper, Shadow, SingleCollectionMain, SingleCollectionWrapper } from "./SingleCollection.styled";
import { SingleCollectionContent } from "./SingleCollectionContent/SingleCollectionContent";

export const SingleCollection = () => {
  return (
    <SingleCollectionWrapper>
      <BannerHeader>
        <Shadow />
        <img src='../../../assets/img/default/collection/2.png' alt='banner' />
      </BannerHeader>
      <div className='container'>
        <BreadcrumpWrapper>
          <BreadCrump />
        </BreadcrumpWrapper>
        <SingleCollectionMain>
          <ProfileSidebar />
          <SingleCollectionContent />
        </SingleCollectionMain>
      </div>
    </SingleCollectionWrapper>
  );
};
